import React         from 'react';
import { Observe }        from 'rewire-core';
import {
  DraggableResizableDialog
  as
  RewireDraggableResizableDialog,
  DraggableResizableDialogProps
  as
  RewireDraggableResizableDialogProps,
  IDraggableResizableDialogProps,
}                         from 'rewire-ui';
import {
  MuiThemeProvider,
}                         from '@material-ui/core/styles';
import {
  dialog2Theme,
  dialog2Styles,
}                         from './Dialog2';
import                         './dialog.css';
import { withStyles }     from '../utility/styles';

class DraggableResizableDialog2 extends React.Component<RewireDraggableResizableDialogProps> {
  render() {
    const {children, DialogProps, ...restProps} = this.props;
    const dialogProps = Object.assign({buttonVariant: 'contained'}, DialogProps);

    return <Observe render={() => (
      <MuiThemeProvider theme={dialog2Theme}>
        <RewireDraggableResizableDialog DialogProps={dialogProps} {...restProps}>
          {children}
        </RewireDraggableResizableDialog>
      </MuiThemeProvider>
    )} />;
  }
}

export default withStyles<IDraggableResizableDialogProps>(dialog2Styles, DraggableResizableDialog2);
